"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("../../../Grid"));
var AddButton_1 = __importDefault(require("./AddButton"));
var List_1 = __importDefault(require("./List"));
var form_1 = require("../../context/form");
var Files = function () {
    var files = (0, form_1.useFormContext)().files;
    var isExistFiles = files && !!files.length;
    return (react_1.default.createElement(Grid_1.default, { container: true },
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement(AddButton_1.default, null)),
        isExistFiles && react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement(List_1.default, null))));
};
exports.default = Files;
